module.exports = "/_next/static/images/tools-2-f05574347a85d42b05eba33e9a73e88a.png";